module.exports = __webpack_public_path__ + "static/img/2.924ea03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/2.png
// module id = rh1l
// module chunks = 0